import * as yup from "yup";

export const WSIBCategorySetupValidationSchema = yup.object().shape({
  label: yup.string().required("Label is required"),
  provinceId: yup.string().required("Province is required"),
  effectiveDate: yup.string().required("Effective Date is required"),
  description: yup.string().max(100, "Maximum length 100 characters"),
});
